import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProcessingDataTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import processingIcon from "../../../../../assets/design-revamp-company/category-icons/processing_no_data_icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const ProcessingDataContents = ({ productId, functionalUnit }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="processing-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("PROCESSING_DATA_TITLE")}
          subDescription={t("PROCESSING_DATA_DESC")}
          isNormal={true}
          number={"15.1B"}
          icon={processingIcon}
        />
      </div>

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-processingdata-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProcessingDataTable
            productId={productId}
            functionalUnit={functionalUnit}
          />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProcessingDataContents;
